<template>
  <img src="~BRAND/assets/login-logo-desktop.svg"/>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/shared/logos/LoginLogoDesktop.vue